var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 2048,
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 2048 2048",
    width: 2048,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h2048v2048h-2048z",
    fill: "#ff9800"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_454307264",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_454304864",
    d: "m0 0h2048v2048h-2048z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_454309136",
    d: "m255.999 255.999h1536v1536h-1536z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fffffe",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1216 448c-64.5237 0-124.585 17.5382-176.111 47.9859-53.9221 31.8662-98.6363 77.8595-129.489 132.705l-11.1532 19.8272-22.2225-3.95197c-8.01142-1.42441-15.7134-2.61969-22.7835-3.37914-6.94961-.745276-14.3067-1.19055-22.2366-1.19055-55.076 0-105.782 17.4414-147.181 47.0481-42.8339 30.6319-75.8316 74.289-93.5457 125.15l-8.0067 22.9902-24.2433-1.61457c-2.91614-.193701-6.02953-.618898-9.14883-1.04291-1.94646-.265748-3.90591-.532678-5.87717-.532678-70.6701 0-134.672 28.6677-181.003 74.9989-46.3347 46.3347-75.0024 110.339-75.0024 181.004 0 70.6725 28.6666 134.675 74.9977 181.006 46.3311 46.3323 110.335 74.9977 181.008 74.9977h416v64.0016h-416c-88.3383 0-168.343-35.8323-226.258-93.7489-57.9154-57.9154-93.7489-137.919-93.7489-226.257 0-88.3312 35.8347-168.336 93.7536-226.255 57.0662-57.065 135.574-92.693 222.37-93.7253 23.4083-53.5004 60.8327-99.4513 107.706-132.972 51.9603-37.1599 115.423-59.0504 184.18-59.0504 9.41221 0 19.1138.633071 28.9878 1.69134 1.73268.185433 3.43701.381496 5.11772.584646 35.6091-56.1827 84.0308-103.453 141.28-137.284 61.193-36.1607 132.347-56.9882 208.61-56.9882 114.863 0 218.86 46.5685 294.142 121.85 74.4142 74.4154 120.767 176.889 121.827 290.171 53.504 23.4083 99.4572 60.8516 132.978 107.74 37.167 51.9874 59.0611 115.476 59.0611 184.238 0 88.3359-35.8359 168.337-93.7513 226.252-57.9178 57.9189-137.923 93.7536-226.255 93.7536h-416v-64.0016h416c70.6654 0 134.671-28.6677 181.004-75.0024 46.3323-46.3323 75.0001-110.332 75.0001-181.002 0-55.0855-17.4449-105.816-47.0587-147.239-30.6331-42.8504-74.2867-75.8634-125.139-93.5741l-22.1492-7.71379.773623-23.4118c.158268-4.813.623623-8.08583 1.08543-11.3516.236221-1.67008.473622-3.34134.473622-4.71378 0-97.193-39.4028-185.196-103.101-248.895-63.6969-63.6957-151.694-103.099-248.892-103.099z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1056 959.29v608.71h-64.001v-608.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1208.14 1188.68-184.14-184.14-184.14 184.14-45.25-45.25 206.76-206.766 22.63-22.624 22.63 22.624 206.76 206.766z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload_image.eeabf015e5ba380e4f38450b3db28dd8.svg";
export { ForwardRef as ReactComponent };